module.exports = __webpack_public_path__ + "media/images/shop-dashboard-device-status-icon-cd9deafce0462f33e229f23253e20471.png";